import { ColorPickerConfigType } from '@/components/ColorOrEmojiPicker/consts';

export const STAFF_ROLE_COLOR_OPTIONS: ColorPickerConfigType[] = [
  { color: '#f87171', hover: '#fee2e2' },
  { color: '#ff8eaf', hover: '#fedfe8' },
  { color: '#fbbf24', hover: '#fef3c7' },
  { color: '#55dd92', hover: '#ccf5de' },
  { color: '#6dc7e1', hover: '#dbeafe' },
  { color: '#7278f5', hover: '#dbeafe' },
];

export const DEFAULT_STAFF_ROLE_ICON_COLOR = STAFF_ROLE_COLOR_OPTIONS[0].color;
